import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION, COMMON_VALIDATION_PARAM } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'reg_match',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: '',
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('Enter pattern to match'),
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} mb={2} />
        <Grid item {...COMMON_STYLES.gridItem}>
          <SourceColumnField
            value={transform.sourceColumns[0] || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].sourceColumns = [e.target.value];
              setFieldValue('transformations', newTransforms);
            }}
            headers={headers}
            disabled={disableForm}
            error={!!errors?.sourceColumns}
            helperText="Select text column to search in"
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.param}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].param = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            label="Regex Pattern *"
            helperText={errors?.param || 'Pattern to match "e.g., \\d to match digits"'}
            error={!!errors?.param}
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.outputColumn || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].outputColumn = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            error={!!errors?.outputColumn}
            helperText={errors?.outputColumn || 'Will contain true/false match results'}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Regex Match - Check if pattern exists (e.g., 'abc123' with \\d → true)" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_RegMatch = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Regex Match?"
  />
);

export default NodeModal_RegMatch;
